import './datepicker.scss';

import flatpickr from 'flatpickr';
import 'flatpickr/dist/flatpickr.min.css';
import { Italian } from 'flatpickr/dist/l10n/it';

const LOCALES = {
  it: Italian,
};

/**
 * version    1.0
 * class      Datepicker
 * classdesc  Generic flatpickr datepicker component. Targets all inputs with class .js-datepicker.
 */
export class Datepicker {
  constructor() {
    this.init();
  }

  init() {
    const inputs = document.querySelectorAll('.js-datepicker');
    if (!inputs.length) return;

    inputs.forEach((input) => {
      const localeKey = input.dataset.locale || 'it';

      flatpickr(input, {
        locale: LOCALES[localeKey] || Italian,
        dateFormat: input.dataset.dateFormat || 'd/m/Y',
        disableMobile: input.dataset.disableMobile !== 'false',
        monthSelectorType: input.dataset.monthSelectorType || 'dropdown',
        defaultDate: input.value || null,
        minDate: input.dataset.minDate || null,
        maxDate: input.dataset.maxDate || null,

        onReady: (selectedDates, dateStr, instance) => {
          const calendar = instance.calendarContainer;
          calendar.style.marginTop = '10px';
          this._initYearPicker(instance);
        },
        onYearChange: (selectedDates, dateStr, instance) => {
          const yearBtn = instance.calendarContainer.querySelector('.flatpickr-year-btn');
          if (yearBtn) yearBtn.textContent = instance.currentYear;
        },
        onOpen: (selectedDates, dateStr, instance) => {
          input.classList.add('is-open');
          this._toggleYearPicker(instance);
        },
        onClose: () => input.classList.remove('is-open'),
      });
    });
  }

  _toggleYearPicker(instance) {
    const isMobile = window.innerWidth < 768;
    const yearBtn = instance.calendarContainer.querySelector('.flatpickr-year-btn');
    const yearPicker = instance.calendarContainer.querySelector('.flatpickr-year-picker');
    const numWrapper = instance.calendarContainer.querySelector('.numInputWrapper');

    if (yearBtn) yearBtn.style.display = isMobile ? '' : 'none';
    if (yearPicker) yearPicker.hidden = true;
    if (numWrapper) numWrapper.style.display = isMobile ? 'none' : '';
  }

  _initYearPicker(instance) {
    const wrapper = instance.calendarContainer.querySelector('.numInputWrapper');
    if (!wrapper) return;

    const currentYear = new Date().getFullYear();
    const minYear = instance.config.minDate
      ? instance.config.minDate.getFullYear()
      : currentYear - 100;
    const maxYear = instance.config.maxDate
      ? instance.config.maxDate.getFullYear()
      : currentYear + 10;

    const yearBtn = document.createElement('button');
    yearBtn.type = 'button';
    yearBtn.className = 'flatpickr-year-btn';
    yearBtn.setAttribute('aria-label', 'Seleziona anno');
    yearBtn.textContent = instance.currentYear;
    yearBtn.style.display = 'none';

    const yearPicker = document.createElement('div');
    yearPicker.className = 'flatpickr-year-picker';
    yearPicker.hidden = true;

    const renderGrid = (centerYear) => {
      const start = centerYear - 5;
      yearPicker.innerHTML = '';

      const nav = document.createElement('div');
      nav.className = 'flatpickr-year-picker__nav';

      const prevBtn = document.createElement('button');
      prevBtn.type = 'button';
      prevBtn.className = 'flatpickr-year-picker__arrow';
      prevBtn.setAttribute('aria-label', 'Anni precedenti');
      prevBtn.innerHTML = '<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 17 17"><g></g><path d="M5.207 8.471l7.146 7.147-0.707 0.707-7.853-7.854 7.854-7.853 0.707 0.707-7.147 7.146z"></path></svg>';
      prevBtn.addEventListener('click', () => renderGrid(start - 6));

      const nextBtn = document.createElement('button');
      nextBtn.type = 'button';
      nextBtn.className = 'flatpickr-year-picker__arrow';
      nextBtn.setAttribute('aria-label', 'Anni successivi');
      nextBtn.innerHTML = '<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 17 17"><g></g><path d="M13.207 8.472l-7.854 7.854-0.707-0.707 7.146-7.146-7.146-7.148 0.707-0.707 7.854 7.854z"></path></svg>';
      nextBtn.addEventListener('click', () => renderGrid(start + 12));

      nav.appendChild(prevBtn);
      nav.appendChild(nextBtn);
      yearPicker.appendChild(nav);

      const grid = document.createElement('div');
      grid.className = 'flatpickr-year-picker__grid';

      for (let y = start; y < start + 12; y += 1) {
        if (y < minYear || y > maxYear) {
          const empty = document.createElement('span');
          grid.appendChild(empty);
          // eslint-disable-next-line no-continue
          continue;
        }

        const cell = document.createElement('button');
        cell.type = 'button';
        cell.className = 'flatpickr-year-picker__cell flatpickr-day';
        cell.textContent = y;

        if (y === instance.currentYear) cell.classList.add('selected');
        if (y === currentYear) cell.classList.add('today');

        cell.addEventListener('click', () => {
          instance.changeYear(y);
          yearBtn.textContent = y;
          yearPicker.hidden = true;
        });

        grid.appendChild(cell);
      }

      yearPicker.appendChild(grid);
    };

    renderGrid(instance.currentYear);

    yearBtn.addEventListener('click', () => {
      yearPicker.hidden = !yearPicker.hidden;
      if (!yearPicker.hidden) renderGrid(instance.currentYear);
    });

    wrapper.after(yearBtn);
    instance.calendarContainer.appendChild(yearPicker);
  }
}
